export default __webpack_public_path__ + "static/media/card_desktop.22992227.svg";